<template>
  <div>
    <!-- Input Baloon -->
    <div class="form-group row">
      <label for="baloon" class="col-sm-10 control-label">{{ $t('ct-baloon-text') }}</label>
      <div class="col-sm-10">
        <textarea type="text" class="form-control" id="baloon" name="baloon" @input="e.remove('baloon')" v-model="config.texts.baloon"></textarea>
        <small class="form-text text-danger" v-if="e.has('baloon')">{{ e.first('baloon') }}</small>
        <small v-if="!e.has('baloon')" class="form-text text-muted">
          {{ $t('ct-checkout-baloon-text-info') }}
        </small>
      </div>
    </div>
    <div class="row">

      <!-- Input Step1_title -->
      <div class="form-group col col-md-5">
        <label for="step1_title" class="control-label">Step1 Title</label>
        <div class="" :class="{'has-error': e.has('step1_title')}">
          <input type="text" class="form-control" :class="{'is-invalid': e.has('step1_title')}" id="step1_title" name="step1_title" @input="e.remove('step1_title')" v-model="config.texts.step1_title">
          <span class="label label-danger" v-if="e.has('step1_title')">{{ e.first('step1_title') }}</span>
        </div>
      </div>

      <!-- Input Step1_text -->
      <div class="form-group col col-md-5">
        <label for="step1_text" class="control-label">Step1 Text</label>
        <div class="" :class="{'has-error': e.has('step1_text')}">
          <input type="text" class="form-control" :class="{'is-invalid': e.has('step1_text')}" id="step1_text" name="step1_text" @input="e.remove('step1_text')" v-model="config.texts.step1_text">
          <span class="label label-danger" v-if="e.has('step1_text')">{{ e.first('step1_text') }}</span>
        </div>
      </div>

    </div>
    <div class="row">
      <!-- Input Step2_title -->
      <div class="form-group col col-md-5">
        <label for="step2_title" class="control-label">Step2 Title</label>
        <div class="" :class="{'has-error': e.has('step2_title')}">
          <input type="text" class="form-control" :class="{'is-invalid': e.has('step2_title')}" id="step2_title" name="step2_title" @input="e.remove('step2_title')" v-model="config.texts.step2_title">
          <span class="label label-danger" v-if="e.has('step2_title')">{{ e.first('step2_title') }}</span>
        </div>
      </div>

      <!-- Input Step2 Text -->
      <div class="form-group col col-md-5">
        <label for="step2_text" class="control-label">Step2 Text</label>
        <div class="" :class="{'has-error': e.has('step2_text')}">
          <input type="text" class="form-control" :class="{'is-invalid': e.has('step2_text')}" id="step2_text" name="step2_text" @input="e.remove('step2_text')" v-model="config.texts.step2_text">
          <span class="label label-danger" v-if="e.has('step2_text')">{{ e.first('step2_text') }}</span>
        </div>
      </div>

    </div>

    <!-- Input BuyButton -->
    <div class="form-group row">
      <label for="buy_button" class="col-sm-10 control-label">{{ $t('ct-checkout-buy-button-text') }}</label>
      <div class="col-sm-10">
        <input type="text" class="form-control" id="buy_button" name="buy_button" @input="e.remove('buy_button')" v-model="config.texts.buy_button" :class="{'is-invalid': e.has('buy_button')}">
        <small class="form-text text-danger" v-if="e.has('buy_button')">{{ e.first('buy_button') }}</small>
      </div>
    </div>

    <!-- Input Buy_button_subtext -->
    <div class="form-group row">
      <label for="buy_button_sub" class="col-sm-10 control-label">{{ $t('ct-checkout-buy-button-subtext') }}</label>
      <div class="col-sm-10">
        <input type="text" class="form-control" id="buy_button_sub" name="buy_button_sub" @input="e.remove('buy_button_sub')" v-model="config.texts.buy_button_sub" :class="{'is-invalid': e.has('buy_button_sub')}">
        <small class="form-text text-danger" v-if="e.has('buy_button_sub')">{{ e.first('buy_button_sub') }}</small>
      </div>
    </div>
    <!-- Input Bottom info text -->
    <div class="form-group row">
      <label for="bottom_info" class="col-sm-10 control-label">{{ $t('ct-checkout-bottom-info-text') }}</label>
      <div class="col-sm-10">
        <textarea type="text" class="form-control" id="bottom_info" name="bottom_info" @input="e.remove('bottom_info')" v-model="config.texts.bottom_info" :class="{'is-invalid': e.has('bottom_info')}"></textarea>
        <small class="form-text text-danger" v-if="e.has('bottom_info')">{{ e.first('bottom_info') }}</small>
      </div>
    </div>
    <!-- Input Pay_button -->
    <div class="form-group row">
      <label for="pay_button" class="col-sm-10 control-label">{{ $t('ct-checkout-pay-button-text') }}</label>
      <div class="col-sm-10">
        <input type="text" class="form-control" id="pay_button" name="pay_button" @input="e.remove('pay_button')" v-model="config.texts.pay_button" :class="{'is-invalid': e.has('pay_button')}">
        <small class="form-text text-danger" v-if="e.has('pay_button')">{{ e.first('pay_button') }}</small>
      </div>
    </div>
    <!-- Input Pay_button -->
    <div class="form-group row">
      <label for="pay_button" class="col-sm-10 control-label">{{ $t('ct-checkout-payment-bottom-info-text') }}</label>
      <div class="col-sm-10">
        <input type="text" class="form-control" id="payment_bottom_info" name="payment_bottom_info" @input="e.remove('payment_bottom_info')" v-model="config.texts.payment_bottom_info" :class="{'is-invalid': e.has('payment_bottom_info')}">
        <small class="form-text text-danger" v-if="e.has('payment_bottom_info')">{{ e.first('payment_bottom_info') }}</small>
      </div>
    </div>

    <!-- Form Submit -->
    <div class="form-group row">
      <div class="col-sm-offset-2 col-sm-10">
        <button type="reset" @click="$emit('cancel')" class="btn btn-outline-info btn-small">
          {{ $t('ct-checkout-select-another-product') }}
        </button>
        <button type="submit" class="btn btn-outline-success btn-small" @click="save">{{ $t('ct-save') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['config', 'e'],

  methods: {
    save() {
      this.e.clear();
      this.e.addValidation({
        buy_button: 'required|max:40',
        step1_title: 'required|max:30',
        step2_title: 'required|max:30',
        buy_button_sub: 'max:240'
      });
      if (this.e.validate(this.config.texts)) {
        this.$emit('save');
      } else {
        this.$nextTick(() => {
          document.querySelector('.is-invalid').focus();
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/Checkout/Form/TextsTwostepConfig.vue